import {useState, useEffect} from "react";

function ScrollToNextSectionButton({ container = document }) {
  // find next section of the nearest one from the center of viewport then scroll to it
  // scroll to the section's center when it's the last one
  const onClickHandler = () => {
    const sections = container.querySelectorAll("section");

    let minDist = window.innerHeight;
    let nextSection = null;
    sections.forEach((section, index) => {
      const sectionRect = section.getBoundingClientRect();

      if (sectionRect.bottom >= 0 && sectionRect.top <= window.innerHeight) {
        let dist = Math.abs(
          window.innerHeight / 2 - sectionRect.top
        );
        if (dist <= minDist) {
          minDist = dist;
          nextSection =
            index < sections.length - 1 ? sections[index+1] : section;
        }
      }
    });

    if (nextSection) {
      nextSection.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };

  // set hide when the last section is the nearest section from the viewport
  let [isHide, setIsHide] = useState(true);

  useEffect(() => {
    const sections = container.querySelectorAll("section");
    const lastSection = sections[sections.length - 1];

    const observer = new IntersectionObserver(
      ([entry]) => {
        console.log("visible");
        setIsHide(entry.isIntersecting);
      },
      { root: null, threshold: 0.1 }
    );

    if (sections) observer.observe(lastSection);

    return () => {
      if (sections) observer.unobserve(lastSection);
    };
  }, []);

  if (isHide) {
    return <></>;
  } else {
    return (
      <>
        <div
          className="fixed bottom-0 flex w-full justify-center text-center z-50 cursor-pointer group"
          onClick={onClickHandler}
        >
          <img
            src={require("../assets/down.png")}
            alt="Down"
            className="h-[2rem] object-contain mb-3 sm:h-[2rem] sm:mb-5"
          />
        </div>
      </>
    );
  }
}
export default ScrollToNextSectionButton;